"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createRecordFromPath = function (path, value) {
    var _a, _b;
    if (path === '') {
        return value;
    }
    var _c = path.split('.'), immediate = _c[0], rest = _c.slice(1);
    if (rest.length === 0) {
        return _a = {}, _a[immediate] = value, _a;
    }
    return _b = {},
        _b[immediate] = createRecordFromPath(rest.join('.'), value),
        _b;
};
exports.default = createRecordFromPath;
//# sourceMappingURL=createRecordFromPath.js.map